module.exports = __webpack_public_path__ + "img/screenshot2.39790ba3.svg";